<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.admin.area_form.page_title") }}</h5>
    </div>
    <div class="centros-formbg">
      <h6>{{ $t("lang.admin.area_form.edit_form_title") }}</h6>
      <div class="centros-form">
        <div v-if="errors.length && !success.show">
          <b>{{ $t("lang.admin.area_form.error_list_title") }}</b>
          <div class="alert alert-danger" role="alert">
            <ul style="list-style-type: circle;margin: 10px">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </div>
        <div v-show="success.show">
          <div class="alert alert-success" role="alert">
            {{ success.message }}
          </div>
        </div>
        <div class="form-group col-md-3 p-0">
          <label for="name">{{ $t("lang.admin.area_form.label_stock") }}</label>
          <label class="form-control" id="name" v-text="input.stock" />
        </div>
        <form @submit.prevent="submitForm()" v-if="input">
          <div class="form-row d-flex align-items-end">
            <div class="form-group col-md-12">
              <label for="email">{{
                $t("lang.admin.area_form.label_description")
              }}</label>
              <input
                type="text"
                class="form-control"
                id="email"
                v-model="input.description"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group select-box col-md-12">
              <label for="reader_type">{{
                $t("lang.admin.area_form.label_select_location")
              }}</label>
              <select
                class="form-control"
                id="reader_type"
                v-model="input.location"
              >
                <option
                  v-for="(location, index) in locations"
                  :key="index"
                  :value="location.id"
                  >{{ location.description }}</option
                >
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group mb-0 col-md-12">
              <button type="submit" class="btn btn-primary active">
                {{ $t("lang.admin.area_form.btn_done") }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddUserForm",
  props: ["id"],
  data() {
    return {
      input: null,
      errors: [],
      locations: [],
      success: {
        show: false,
        message: this.$t("lang.admin.area_form.success_edit")
      },
      errorLabels: {
        description: this.$t("lang.admin.area_form.errors.description"),
        location: this.$t("lang.admin.area_form.errors.location"),
        notFound: this.$t("lang.admin.area_form.errors.not_found"),
        failed: this.$t("lang.messages.label_something_went_wrong")
      }
    };
  },
  async mounted() {
    try {
      this.locations = await this.$api.location.list();
      this.input = await this.$api.area.get(this.id);
    } catch (error) {
      this.errors.push(this.errorLabels.notFound);
    }
  },
  methods: {
    async submitForm() {
      let input = Object.assign({}, this.input);

      if (this.validate()) {
        delete input.location_description;
        delete input.stock;
        console.log(input);

        try {
          let response = await this.$api.area.update(input);
          this.success.show = true;
        } catch (error) {
          this.errors.push(this.errorLabels.failed);
          console.error(error);
        }
      }
    },
    validate() {
      this.errors = [];
      this.success.show = false;

      let error = false;

      if (!this.input.description) {
        error = true;
        this.errors.push(this.errorLabels.description);
      }

      if (!this.input.location) {
        error = true;
        this.errors.push(this.errorLabels.location);
      }

      if (error) {
        return false;
      }

      return true;
    }
  }
};
</script>
